<template>
  <vue-modal :active="active" type="small" @closed="$emit('closed')">
    <vue-filters @applied="$modal.close('carts-filters')">
      <h3 class="border-b border-gray-lighter pb-2 mb-4">Filtrer</h3>
      <div class="mb-8">
        <div class="flex items-center mb-2">
          <span class="w-1/3 mr-2">Statut</span>
          <vue-filter param="status" :options="filterStatusOptions"/>
        </div>
      </div>
    </vue-filters>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import VueFilters from '../filters/Filters.vue';
import VueFilter from '../filters/Filter.vue';

export default {
  components: { VueFilters, VueFilter },

  mixins: [modal],

  computed: {
    filterStatusOptions() {
      return [
        { label: 'Expiré', value: 'expired' },
        { label: 'Expire bientôt', value: 'expiring-soon' },
        { label: 'En cours', value: 'not-expired' },
      ];
    },
  },
};
</script>
